import React from "react"
import withHooks from "../../Common/jsx/WithHooks"
import QuestionNumSuiteMcq from "./QuestionNumSuiteMcq"
import { Col, Container, Row } from "react-bootstrap"
import QuestionHeader from "./QuestionHeader"
import QuestionFooter from "./QuestionFooter"
import QuestionNumSuiteInput from "./QuestionNumSuiteInput"
import QuestionSpatialSuiteMcq from "./QuestionSpatialSuiteMcq"

class Question extends React.Component {
  constructor(props) {
    super(props)

    this.dMgr = this.props.DebugManager(this.constructor.name)
    this.dMgr.activate(true)
    this.dMgr.debug("const_props:", this.props)

    this.state = {
      isReadyToRender: true,
      answerGiven: false,
      chosenAnswer: false,
    }

    this.dMgr.debug("init_state:", this.state)

    this.giveAnswer = this.giveAnswer.bind(this)
    this.updatePlayScore = this.updatePlayScore.bind(this)
    this.setChosenAnswer = this.setChosenAnswer.bind(this)
  }

  componentDidMount() {
    this.props.setSplashFilterBrightness(10)
  }

  giveAnswer() {
    if (!this.state.answerGiven) {
      this.setState({ answerGiven: true }, () => this.updatePlayScore(-1))
    }
  }

  setChosenAnswer(chosenAnswer) {
    this.setState({ chosenAnswer })
  }

  updatePlayScore(direction) {
    let playScore = { ...this.props.playScore }
    if (direction > 0) {
      playScore.right++
    } else {
      playScore.wrong++
    }
    this.dMgr.debug("updatePlayScore:", playScore)

    this.props.updatePlayScore(playScore)
  }

  render() {
    if (!this.state.isReadyToRender) {
      this.dMgr.debug("render:", "not ready")
      return null
    }
    this.dMgr.rendering()

    this.dMgr.debug("questionType.shortname:", this.props.currentQuestion.questionType.shortname)

    let questionObject
    switch (this.props.currentQuestion.questionType.shortname) {
      default:
      case "num_suite_mcq":
        questionObject = (
          <QuestionNumSuiteMcq
            key={"question" + this.props.currentQuestion.id}
            currentQuestion={this.props.currentQuestion}
            updatePlayScore={this.updatePlayScore}
            setChosenAnswer={this.setChosenAnswer}
            answerGiven={this.state.answerGiven}
            chosenAnswer={this.state.chosenAnswer}
            remainingQuestionsId={this.props.remainingQuestionsId}
          />
        )
        break
      case "num_suite_input":
        questionObject = (
          <QuestionNumSuiteInput
            key={"question" + this.props.currentQuestion.id}
            currentQuestion={this.props.currentQuestion}
            updatePlayScore={this.updatePlayScore}
            setChosenAnswer={this.setChosenAnswer}
            answerGiven={this.state.answerGiven}
            chosenAnswer={this.state.chosenAnswer}
            remainingQuestionsId={this.props.remainingQuestionsId}
          />
        )
        break
      case "spatial_suite_mcq":
        questionObject = (
          <QuestionSpatialSuiteMcq
            key={"question" + this.props.currentQuestion.id}
            currentQuestion={this.props.currentQuestion}
            updatePlayScore={this.updatePlayScore}
            setChosenAnswer={this.setChosenAnswer}
            answerGiven={this.state.answerGiven}
            chosenAnswer={this.state.chosenAnswer}
            remainingQuestionsId={this.props.remainingQuestionsId}
          />
        )
        break
    }

    let toRender = (
      <>
        <Container>
          <QuestionHeader remainingQuestionsId={this.props.remainingQuestionsId} playScore={this.props.playScore} selectedQuestionsCount={this.props.selectedQuestionsCount} />
          <Row>
            <Col md={12}>{questionObject}</Col>
          </Row>
          <QuestionFooter
            backMenu={this.props.backMenu}
            updatePlayScore={this.props.updatePlayScore}
            chosenAnswer={this.state.chosenAnswer}
            answerGiven={this.state.answerGiven}
            giveAnswer={this.giveAnswer}
            remainingQuestionsId={this.props.remainingQuestionsId}
            getNextQuestion={this.props.getNextQuestion}
          />
        </Container>
      </>
    )

    this.dMgr.renderDone()
    return toRender
  }
}
export default withHooks(Question)
